'use strict';

namespace Core {

    class BookingComplete {
        manageBookingStarted: boolean;
        lightboxOpened: boolean;
        bookingSummarySurname: string;
        payLaterEnabled: boolean;

        constructor(
            private $location: ng.ILocationService,
            private $routeParams,
            private $scope,
            private $window,
            private agentModeService,
            private analytics,
            private broker: Broker,
        ) {
            this._initPage();
            this.payLaterEnabled = TRPCONFIG.Domain.BuyNowPayLaterEnabled && this.$location.search().pl === '1';
            if (TRPCONFIG.Domain.isAgentMode) {
                const bookingId = this.$routeParams.ref.split('|')[0];
                if (bookingId && bookingId.split('/')[1]) {
                    agentModeService.getBookingContact(bookingId.split('/')[1]).then(result => {
                        this.bookingSummarySurname = result.LastName;
                    });
                }
            }
            if (TRPCONFIG.Domain.HideBookingRefOnConfirmation) {
                this.$location.replace();
                this.$location.url('booking/complete');
            }
            if ((this.$routeParams.paypal === 'true') && this.$routeParams.tripData) {
                const tripData = JSON.parse(decodeURIComponent(this.$routeParams.tripData));
                this.analytics.track('eCommercePaypal', 'purchase', tripData);
            }
            if(sessionStorage.getItem('eCommercePurchaseData')) {
                const purchaseData = JSON.parse(sessionStorage.getItem('eCommercePurchaseData') || '{}');
                this.$window.dataLayer.push(purchaseData);
                sessionStorage.removeItem('eCommercePurchaseData');
            }
        }

        private _initPage() {
            this.broker.publish('unblock');
            this.$scope.$emit('unblock');
            this.broker.subscribe('bookingComplete', 'lightboxOpened', () => this.lightboxOpened = true);
            this.broker.subscribe('bookingComplete', 'lightboxCloseClicked', () => this.lightboxOpened = false);
            this.broker.subscribe('bookingComplete', 'manageBookingClicked', () => this.manageBookingStarted = true);
            this.manageBookingStarted = false;
        }

    }

    angular
        .module('core')
        .controller('BookingComplete', BookingComplete);
}
